import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Auth, FC_Logout, System } from "./actions";
import { StoreState } from "./reducers";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  FC_CheckLoggedIn,
  NavToogle,
  RemovePopupAlert,
  PushPopupAlert,
} from "./actions";

//* Components
import Navigation from "./components/Navigation/Navigation";
import ProtectedRoute from "./components/PrivateRoute/PrivateRoute";

//* Routes

import { Login } from "./containers/Login/Login";
import LazyLoading from "./components/LazyLoading/LazyLoading";
import Popup, { PopupAlertData } from "./components/Alert/Popup";
import { GeneralFeedback } from "./components/GeneralFeedback/GeneralFeedback";
import { MdFeedback } from "react-icons/md";
import AppLoading from "./components/AppLoading/AppLoading";
import { ForgetPassword } from "./containers/ForgetPassword/ForgetPassword";

const AdminDashboard = lazy(() =>
  import("./containers/AdminDashboard/AdminDashboard").then(
    ({ AdminDashboard }) => ({
      default: AdminDashboard,
    })
  )
);

const CreateEvent = lazy(() =>
  import("./containers/Events/CreateEvent").then(({ CreateEvent }) => ({
    default: CreateEvent,
  }))
);

const Events = lazy(() =>
  import("./containers/Events/Events").then(({ Events }) => ({
    default: Events,
  }))
);

const CreateNews = lazy(() =>
  import("./containers/News/CreateNews").then(({ CreateNews }) => ({
    default: CreateNews,
  }))
);

const News = lazy(() =>
  import("./containers/News/News").then(({ News }) => ({
    default: News,
  }))
);

const Activities = lazy(() =>
  import("./containers/Activities/Activities").then(({ Activities }) => ({
    default: Activities,
  }))
);

const AddActivities = lazy(() =>
  import("./containers/Activities/AddActivities").then(({ AddActivities }) => ({
    default: AddActivities,
  }))
);

const CreateMember = lazy(() =>
  import("./containers/Users/AddMember").then(({ AddMember }) => ({
    default: AddMember,
  }))
);

const VolunteersList = lazy(() =>
  import("./containers/Volunteers/VolunteersList").then(
    ({ VolunteersList }) => ({
      default: VolunteersList,
    })
  )
);

const MembersList = lazy(() =>
  import("./containers/Users/MembersList").then(({ usersList }) => ({
    default: usersList,
  }))
);

const Profile = lazy(() =>
  import("./containers/Profile/Profile").then(({ Profile }) => ({
    default: Profile,
  }))
);

const Gallery = lazy(() =>
  import("./containers/Gallery/Gallery").then(({ Gallery }) => ({
    default: Gallery,
  }))
);

const WelcomeMessage = lazy(() =>
  import("./containers/WelcomeMessage/WelcomeMessage").then(
    ({ WelcomeMessage }) => ({
      default: WelcomeMessage,
    })
  )
);

const Programmes = lazy(() =>
  import("./containers/Programmes/Programmes").then(({ Programmes }) => ({
    default: Programmes,
  }))
);

const Gifts = lazy(() =>
  import("./containers/Gifts/Gifts").then(({ Gifts }) => ({
    default: Gifts,
  }))
);

const Videos = lazy(() =>
  import("./containers/Videos/Videos").then(({ Videos }) => ({
    default: Videos,
  }))
);

const Team = lazy(() =>
  import("./containers/Team/Team").then(({ Team }) => ({
    default: Team,
  }))
);

const Prayers = lazy(() =>
  import("./containers/Prayers/Prayers").then(({ Prayers }) => ({
    default: Prayers,
  }))
);

// props for the component
interface AppProps {
  auth: Auth;
  system: System;
  isAuthenticated: boolean;
  FC_CheckLoggedIn: Function;
  FC_Logout: Function;
  NavToogle: Function;
  RemovePopupAlert: () => void;
  PushPopupAlert: (alert: PopupAlertData) => void;
}

interface AppState {
  loading: boolean;
  socket: any;
  feedback: boolean;
}

class _App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {
      loading: true,
      socket: null,
      feedback: false,
    };
  }

  componentDidMount() {
    //* check if the user is logged in
    this.props.FC_CheckLoggedIn();
  }

  toogleFeedback = () =>
    this.setState({
      feedback: !this.state.feedback,
    });

  render() {
    const authenticationPath = "/login";
    // app loading
    if (this.props.auth.loading === true) {
      return <AppLoading />;
    }
    return (
      <Router>
        <Navigation
          isAuthenticated={this.props.isAuthenticated}
          email={this.props.auth.user?.username}
          Logout={this.props.FC_Logout}
          NavToogle={this.props.NavToogle}
          navActive={this.props.system.navigation}
          auth={this.props.auth}
        />
        <div
          className={`mb-3 fixed top-1/5 right-1`}
          role="alert"
          style={{ zIndex: 999999999 }}
        >
          {this.props.system.PopupAlerts !== null &&
            this.props.system.PopupAlerts.length > 0 &&
            this.props.system.PopupAlerts.map((item, i) => (
              <Popup
                title={item.title}
                description={item.description}
                theme={item.theme}
              />
            ))}
        </div>
        {/* {this.state.feedback === true ? (
          <GeneralFeedback close={this.toogleFeedback} />
        ) : (
          <section className="fixed bottom-2 right-2 animate__animated animate__fadeInUp animate__faster">
            <button
              onClick={this.toogleFeedback}
              className="text-white px-4 w-auto h-10 bg-green-600 rounded-full hover:bg-green-700 active:shadow-lg mouse shadow transition ease-in duration-200 focus:outline-none"
            >
              <MdFeedback className="inline-block mr-2" />
              <span>Feedback</span>
            </button>
          </section>
        )} */}

        <div
          className={`pt-16 ${
            this.props.isAuthenticated === true
              ? this.props.system.page_has_sub_nav === true
                ? "lg:ml-64 lg:pr-1"
                : "pt-16 lg:ml-52 pl-2 lg:pr-1"
              : "w-full"
          }`}
        >
          <div
            className={`${
              this.props.isAuthenticated === true ? "max-w-screen-2xl pl-2" : ""
            }  mx-auto`}
          >
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/forget-password" component={ForgetPassword} />
              <Suspense fallback={<LazyLoading />}>
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/profile"
                  component={Profile}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/dashboard"
                  component={AdminDashboard}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/admin"
                  component={AdminDashboard}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/events"
                  component={Events}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/add-event"
                  component={CreateEvent}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/news"
                  component={News}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/add-news"
                  component={CreateNews}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/members"
                  component={MembersList}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/add-member"
                  component={CreateMember}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/volunteers"
                  component={VolunteersList}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/activities"
                  component={Activities}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/add-activity"
                  component={AddActivities}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/gallery"
                  component={Gallery}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/welcome-message"
                  component={WelcomeMessage}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/programmes"
                  component={Programmes}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/gifts"
                  component={Gifts}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/videos"
                  component={Videos}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/team"
                  component={Team}
                />
                <ProtectedRoute
                  isAuthenticated={this.props.auth.isAuthenticated}
                  authenticationPath={authenticationPath}
                  exact
                  path="/prayers"
                  component={Prayers}
                />
              </Suspense>
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = ({
  auth,
  system,
}: StoreState): {
  auth: Auth;
  isAuthenticated: boolean;
  system: System;
} => {
  return {
    auth: auth,
    isAuthenticated: auth.isAuthenticated,
    system: system,
  };
};

export const App = connect(mapStateToProps, {
  FC_CheckLoggedIn,
  FC_Logout,
  NavToogle,
  RemovePopupAlert,
  PushPopupAlert,
})(_App);
